import store from '@/store';

export default (to, from, next) => {
  const profilePath = '/account';
  const isUserSuspended = store.getters.isUserSuspended;

  if (isUserSuspended) {
    next(profilePath);
    return false;
  }

  next();
};
